export default {
  items: (state) => state.items,
  paginator: (state) => state.paginator,
  sort: (state) => state.sort,
  current: (state) => state.current,
  isLoading: (state) => state.isLoading,
  dqlFields: (state) => state.dqlFields,
};
